export const OPENAI_MODELS = [
  { id: "gpt-4o-mini", label: "GPT-4o mini" },
  { id: "gpt-4o", label: "GPT-4o" },
  { id: "gpt-5.4-mini", label: "GPT-5.4 mini" },
  { id: "gpt-5.4", label: "GPT-5.4" },
  { id: "gpt-5.5", label: "GPT-5.5" }
];

export const DEFAULT_OPENAI_MODEL = "gpt-4o-mini";

export const PLAN_FREE = "free";
export const PLAN_PRO = "pro";
export const PLAN_OPTIONS = [
  { id: PLAN_FREE, label: "Free" },
  { id: PLAN_PRO, label: "Pro · $29/month" }
];

export const VIEW_SCOPE_WORKSTREAM = "workstream";
export const VIEW_SCOPE_WORKSPACE = "workspace";

export const ROLE_OWNER = "owner";

export const PROFILE_TYPE_HUMAN = "human";
export const PROFILE_TYPE_AI_AGENT = "ai_agent";

export const ENGINEER_LEVELS = ["Level I", "Level II", "Level III", "Senior", "Staff"];
export const DEFAULT_ENGINEER_LEVEL = "Level II";

export const AGENT_MODELS = ["gpt-5.4", "gpt-5.5"];
export const AGENT_MODEL_OPTIONS = [
  { id: "gpt-5.4", label: "Standard · GPT-5.4" },
  { id: "gpt-5.5", label: "Advanced · GPT-5.5" }
];
export const DEFAULT_AGENT_MODEL = "gpt-5.4";
export const AGENT_REASONING_EFFORTS = ["low", "medium", "high"];
export const AGENT_REASONING_EFFORT_OPTIONS = [
  { id: "low", label: "Low" },
  { id: "medium", label: "Medium" },
  { id: "high", label: "High" }
];
export const DEFAULT_AGENT_REASONING_EFFORT = "medium";

export const FIBONACCI_COMPLEXITIES = [1, 2, 3, 5, 8, 13, 21];
export const DEFAULT_FIBONACCI_COMPLEXITY = 3;

export const TICKET_TYPE_STORY = "Story";
export const TICKET_TYPE_SUBTASK = "Sub-task";

export const DELIVERY_STATUS_BACKLOG = "Backlog";
export const DELIVERY_STATUSES = [
  DELIVERY_STATUS_BACKLOG,
  "To do",
  "In progress",
  "In review",
  "Done"
];

export const JIRA_STATUS_DRAFT = "Draft";

export const ACTIVE_AGENT_STATUSES = ["queued", "planning", "implementing", "creating_pull_request"];
export const AGENT_STATUS_WAITING_FOR_CLARIFICATION = "waiting_for_clarification";

export const ACTIVE_JOB_STATUSES = ["queued", "running"];

export const GANTT_SOURCE_MANUAL = "manual";
export const GANTT_SOURCE_PROJECT = "project";
export const GANTT_SOURCE_WORKSPACE = "workspace";

export const WBS_SOURCE_MANUAL = "manual";
export const WBS_SOURCE_IMAGE = "image";
export const WBS_SOURCE_REQUIREMENTS = "requirements";
export const WBS_SOURCE_TASKS = "tasks";
